/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const loginPageStyle = {
  container: (theme: Theme) => ({
    paddingTop: "4rem",
    paddingBottom: "4rem",
    [theme.breakpoints.up("sm")]: {
      paddingTop: "6rem",
      paddingBottom: "9rem",
    },
  }),
  card: (theme: Theme) => ({
    padding: "1rem",
    [theme.breakpoints.up("sm")]: {
      padding: "3rem",
    },
  }),
};

export default loginPageStyle;
